module.exports = __webpack_public_path__ + "static/media/track-roadamerica.231a0060.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/track-roadamerica.png
// module id = 1036
// module chunks = 0